module.exports = __webpack_public_path__ + "media/images/theCollectionCatalog-5ff310a4e5b62b95041badc3a4e7b317.png";